import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { ChecklistService } from './../../../shared/services/checklist.service';
import { ActiveUserLocalDataService } from './../../../shared/services/active-user-local-data.service';
import {
  GetCheckListForClientRequest,
  GetCheckListForClientResponse,
  CheckListForClientModel,
  PostCheckListAnswerRequest,
} from './../../../shared/models/checklist.models';

@Component({
  templateUrl: 'checklist.component.html',
  styleUrls: ['./checklist.component.scss'],
})
export class ChecklistComponent implements OnInit {
  checklistResponse: GetCheckListForClientResponse | null = null;
  textareaTextDict: { [key: string]: string } = {};
  imageDict: { [key: string]: Uint8Array } = {};
  errorMessage: string = '';
  popupVisibleError: boolean = false;
  isPopupVisible = false;
  isMobile: boolean = false;
  loading: boolean = false;
  selectedItems: CheckListForClientModel[] = [];
  flag: boolean = true;

  constructor(
    private checklistService: ChecklistService,
    private activeUserLocalDataService: ActiveUserLocalDataService,
    private router: Router
  ) {}

  ngOnInit() {
    this.checkIfMobile();
    this.loadChecklist();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkIfMobile();
  }

  private checkIfMobile() {
    this.isMobile = window.innerWidth <= 768;
  }

  loadChecklist() {
    this.loading = true;
    const startNewVoucherData = this.activeUserLocalDataService.getStartNewVoucherData();
    if (!startNewVoucherData) {
      this.router.navigate(['/pick-car']);
      return;
    }
    const request: GetCheckListForClientRequest = {
      clientId: startNewVoucherData.clientId,
      carId: startNewVoucherData.carId,
    };
    this.checklistService.getCheckListForClient(request).subscribe((response: GetCheckListForClientResponse) => {
      this.checklistResponse = response;
      if (!this.checklistResponse || !this.checklistResponse.checkList || this.checklistResponse.checkList.length === 0) {
    
        this.router.navigate(['/input-odometer']);
      } else {
        
      }
      if (this.checklistResponse?.checkList) {
        this.checklistResponse.checkList.forEach((item) => {
          if (item.allowInputComment) {
            this.textareaTextDict[item.id.toString()] = '';
          }
        });
        this.selectedItems = [...this.checklistResponse.checkList];
      }
      this.updateChecklistItemStyles();
      this.loading = false;
    });
  }

  continueClicked() {
    let allQuestionsAnswered = true;
    let allImagesProvided = true;
  
    this.checklistResponse?.checkList.forEach(item => {
      const [isAnswered, isImageProvided] = this.checkQuestionCompletion(item);
  
      if (!isAnswered) {
        allQuestionsAnswered = false;
      }
  
      if (!isImageProvided) {
        allImagesProvided = false;
      }
  
      if (!allQuestionsAnswered || !allImagesProvided) {
        return;
      }
    });
  
    if (allQuestionsAnswered && allImagesProvided) {
      this.saveChecklistData();
      this.router.navigate(['/input-odometer']);
    } else {
      if (!allQuestionsAnswered && !allImagesProvided) {
        this.errorMessage = "Lūdzu atbildiet uz visiem jautājumiem un pievienojiet trūkstošos attēlus!";
      } else if (!allQuestionsAnswered) {
        this.errorMessage = "Lūdzu atbildiet uz visiem jautājumiem!";
      } else if (!allImagesProvided) {
        this.errorMessage = "Lūdzu pievienojiet trūkstošos attēlus!";
      }
  
      this.popupVisibleError = true;
    }
  }

  saveChecklistData() {
    const startNewVoucherData =
        this.activeUserLocalDataService.getStartNewVoucherData();
    if (startNewVoucherData && this.checklistResponse?.checkList) {
        startNewVoucherData.checklistAnswers =
            this.checklistResponse.checkList.map((item) => ({
                checklistQuestionId: item.id,
                checklistAnswer: item.selectedAnswer,
                comment: this.textareaTextDict[item.id.toString()] || '',
                image: this.imageDict[item.id.toString()] || new Uint8Array(),
            }));
    }
}

checkQuestionCompletion(item: CheckListForClientModel): [boolean, boolean] {
  const isAnswered = item.possibleAnswers ? item.possibleAnswers.includes(item.selectedAnswer) : false;
  const isImageProvided = !item.mandatoryImage || !!this.imageDict[item.id.toString()];
  return [isAnswered, isImageProvided];
}

isChecklistItemCompleted(item: CheckListForClientModel): boolean {
  const [isAnswered, isImageProvided] = this.checkQuestionCompletion(item);
  return isAnswered && isImageProvided;
}

updateChecklistItemStyles() {
  if (this.checklistResponse?.checkList) {
    this.checklistResponse.checkList.forEach((item, index) => {
      const accordionElement = document.querySelector('.dx-accordion');
      const itemElement = accordionElement?.querySelectorAll('.dx-accordion-item')[index];
      if (itemElement) {
        if (this.isChecklistItemCompleted(item)) {
          itemElement.classList.add('completed');
          itemElement.classList.remove('incomplete');
        } else {
          itemElement.classList.add('incomplete');
          itemElement.classList.remove('completed');
        }
      }
    });
  }
}

toggleAccordionStyle() {
  const accordionElement = document.querySelector('.dx-accordion');
  if (accordionElement) {
    accordionElement.classList.toggle('custom-style');
  }
}

  getDateCssClass(date: Date | undefined): string {
    if (!date) {
      return 'date-invalid';
    }
    const now = new Date();
    const inputDate = new Date(date);
    const daysDifference =
      (inputDate.getTime() - now.getTime()) / (1000 * 3600 * 24);
    if (daysDifference < 0) {
      return 'date-invalid';
    } else if (daysDifference >= 0 && daysDifference <= 10) {
      return 'date-warning';
    } else if ( daysDifference >= 11) {
      return 'date-valid';
    } else {
      return '';
    }
  }

  calculateRemainingDays(endDate: Date | undefined): number {
    if (!endDate) {
      return 0;
    }
    const remainingDays = Math.ceil(
      (new Date(endDate).getTime() - new Date().getTime()) / (1000 * 3600 * 24)
    );
    return remainingDays > 0 ? remainingDays : 0;
  }

  onContentReady(e: any) {
    if (this.flag && this.checklistResponse?.checkList) {
      for (let i = 0; i < this.checklistResponse.checkList.length; i++) {
        e.component.expandItem(i);
      }
      this.flag = false;
    }
  }

  navigateToPickClient() {
    this.router.navigate(['/pick-client']);
  }

  async onFileUploaderValueChanged(event: any, checklistItemId: number) {
    const file = event.value[0];
    if (file) {
        const reader = new FileReader();
        reader.onload = async () => {
            const arrayBuffer = reader.result as ArrayBuffer;
            const image = new Uint8Array(arrayBuffer);

            const resizedImage = await this.resizeImage(image);

            this.imageDict[checklistItemId.toString()] = resizedImage;

            const checklistItem = this.checklistResponse?.checkList.find(item => item.id === checklistItemId);
            if (checklistItem) {
                const [isAnswered, isImageProvided] = this.checkQuestionCompletion(checklistItem);
                this.updateChecklistItemStyles();
            }
        };
        reader.readAsArrayBuffer(file);
    }
}

arrayBufferToBase64(buffer: Uint8Array): string {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}
  
  async resizeImage(image: Uint8Array): Promise<Uint8Array> {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
  
    if (!ctx) {
      throw new Error('Failed to get 2D context');
    }
  
    const img = new Image();
  
    return new Promise((resolve, reject) => {
      img.onload = () => {
        const maxSize = 1024;
        let width = img.width;
        let height = img.height;
  
        if (width > height) {
          if (width > maxSize) {
            height *= maxSize / width;
            width = maxSize;
          }
        } else {
          if (height > maxSize) {
            width *= maxSize / height;
            height = maxSize;
          }
        }
  
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);
  
        canvas.toBlob((blob) => {
          if (blob) {
            const reader = new FileReader();
            reader.onload = () => {
              resolve(new Uint8Array(reader.result as ArrayBuffer));
            };
            reader.onerror = reject;
            reader.readAsArrayBuffer(blob);
          } else {
            reject(new Error('Failed to create blob from canvas'));
          }
        }, 'image/jpeg');
      };
      img.onerror = reject;
      img.src = URL.createObjectURL(new Blob([image]));
    });
  }

  removeFile(checklistItemId: number) {
    delete this.imageDict[checklistItemId.toString()];
  }

  onAnswerChange(checklistItem: CheckListForClientModel) {
    this.updateChecklistItemStyles();
  }
}